import { Grid, useEventCallback, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { AccordionEditDataControl as AccordionEditControlDataVM } from 'shell/view-models/edit-data-control';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import FlagValidationFiscalCode from '../../../../shell/components/shared/flag-validation-fiscal-code/flag';

interface FormEditControlDataProps {
  disabled?: boolean;
  values?: AccordionEditControlDataVM;
  isEditMode?: boolean;
  onChange: (
    key: keyof AccordionEditControlDataVM,
    value: AccordionEditControlDataVM[keyof AccordionEditControlDataVM]
  ) => void;
}

const FormEditControlDataComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
}: FormEditControlDataProps): React.ReactElement => {
  const handleFlagChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('flag', event.target.value);
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data decorrenza"
          value={values?.dateValidity || null}
          disabled={isEditMode ? false : disabled}
          onChange={(dataValue) => {
            onChange('dateValidity', dataValue || null);
          }}
          renderInput={(params) => (
            <PmiTextField {...params} fullWidth error={false} helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FlagValidationFiscalCode
          disabled={isEditMode ? false : disabled}
          value={values?.flag || ''}
          onChange={handleFlagChange}
        />
      </Grid>
    </Grid>
  );
};

FormEditControlDataComponent.displayName = 'Form Edit Control data component';

const FormEditControlData = memo(FormEditControlDataComponent);

export default FormEditControlData;
